import { useEffect, useRef } from "react";
import { useAppSelector } from "../../redux/configureStore";
import { differenceInMilliseconds, parseISO, subMinutes } from "date-fns";
import { useGetRefreshTokenAuthMutation } from "./authApi";
import { authSelector } from "./selectors";

function useRefreshTokenSubscription() {
  const timeout = useRef<NodeJS.Timeout>();
  const { refresh_token, expires_at } = useAppSelector(authSelector);
  const [getRefreshTokenAuth] = useGetRefreshTokenAuthMutation();

  useEffect(() => {
    if (expires_at && refresh_token) {
      const timeToExpiration = differenceInMilliseconds(
        subMinutes(parseISO(expires_at), 10),
        Date.now(),
      );
      timeout.current = setTimeout(() => {
        getRefreshTokenAuth(refresh_token);
      }, timeToExpiration); // Execute 10 minutes before expiration
    }
    return () => timeout.current && clearTimeout(timeout.current);
  }, [expires_at, getRefreshTokenAuth, refresh_token]);
}

export default useRefreshTokenSubscription;
